// extracted by mini-css-extract-plugin
export var backdropBlur = "_ct-0";
export var contentCard = "_ct-5";
export var frame = "_ct-2";
export var image = "_ct-4";
export var imagePane = "_ct-3";
export var modal = "_ct-1";